import { bool, node, oneOfType, shape, string } from 'prop-types';

import DailyRewardImage from '~/components/DailyRewardImage';

import style from './DailyRewardPopupsBody.module.scss';

export default function DailyRewardPopupsBody({
  description,
  image: { src, icon, image, alt, collected } = {},
  title,
}) {
  return (
    <>
      {(src || image) && (
        <DailyRewardImage
          path={image}
          src={src}
          alt={alt || ''}
          collected={collected}
          className={icon ? style.iconImage : style.image}
          classNameCheck={style.check}
        />
      )}
      {title && <span className={style.title}>{title}</span>}
      {description && <p className={style.description}>{description}</p>}
    </>
  );
}

DailyRewardPopupsBody.propTypes = {
  description: oneOfType([string, node]),
  image: shape({
    alt: string,
    src: string,
    icon: bool,
    image: string,
    collected: bool,
  }),
  title: oneOfType([string, node]),
};
